import { Config } from '../../config'

export const mglabsolutionsConfig: Config = {
  partner: 'mglabsolutions',
  catalog: 'partner',
  displayName: 'MG Lab Solutions',
  accentColor: '#007aff',
  host: 'labfurniture.mglabsolutions.com',
}

